// src/pages/Account/ChangePasswordPage.jsx
import { useState } from 'react';
import { Box, Paper, TextField, Button, Typography } from '@mui/material';
import axiosInstance from '../../axiosInstance';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';

export default function ChangePasswordPage() {
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const { refreshAuthData } = useAuth();

  const onSave = async () => {
    if (!password || password.length < 8) return toast.warn('La contraseña debe tener al menos 8 caracteres');
    if (password !== password2) return toast.warn('Las contraseñas no coinciden');
    try {
      await axiosInstance.post('/auth/change-password/', { password });
      toast.success('Contraseña actualizada');
      await refreshAuthData?.();
      // Opcional: redirige a dashboard
      window.location.href = '/';
    } catch (e) {
      toast.error(e?.response?.data?.error || 'No se pudo cambiar la contraseña');
    }
  };

  return (
    <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
      <Paper sx={{ p: 3, maxWidth: 420, width: '100%', borderRadius: 3 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>Cambiar contraseña</Typography>
        <TextField
          label="Nueva contraseña"
          fullWidth
          type="password"
          sx={{ mb: 2 }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <TextField
          label="Confirmar contraseña"
          fullWidth
          type="password"
          sx={{ mb: 2 }}
          value={password2}
          onChange={(e) => setPassword2(e.target.value)}
        />
        <Button variant="contained" onClick={onSave} fullWidth>Guardar</Button>
      </Paper>
    </Box>
  );
}
